module.exports = __webpack_public_path__ + "img/status1.fa4e8f3b.png";